import React from 'react';
import PropTypes from 'prop-types';

class MenuItem extends React.Component {
    render() {
        const classes = ['menu__item'];
        const { isActive, isDisabled } = this.props;
        let onClick = this.props.onClick;
        if (isActive) {
            classes.push('menu__item--active');
        }
        if (isDisabled) {
            classes.push('menu__item--disabled');
            onClick = undefined;
        }
        return (
            <li className={classes.join(' ')} onClick={onClick}>
                {this.props.children}
            </li>
        );
    }
}

MenuItem.propTypes = {
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

MenuItem.defaultProps = {
    isActive: false,
    isDisabled: false,
    onClick: undefined,
    children: null,
};

export default MenuItem;
